import React, { FC } from 'react';
import { SVGTooltipProps } from '@utils';
import { SvgWithTooltip } from './SvgWithTooltip';

export const UserUnavailable: FC<SVGTooltipProps> =({ onClick, divClassName, tooltip }) => (
  <SvgWithTooltip 
    onClick={onClick}
    divClassName={divClassName}
    tooltip={tooltip}
  >
    <svg 
      width="100%" 
      height="100%" 
      viewBox="0 0 24 24" 
      fill="none" 
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle 
        cx="12" 
        cy="12" 
        r="12" 
        fill="#F23C34"
      />
      <line 
        x1="4" 
        y1="12.5" 
        x2="20" 
        y2="12.5" 
        stroke="white" 
        strokeWidth="3"
      />
    </svg>
  </SvgWithTooltip>
);
